import { memo, useCallback } from 'react';

import { PanelLeftCloseIcon, PanelLeftOpenIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useAssetModalLeftPanel } from '~/components/AssetModalV2/AssetModalLeftPanelContextProvider';

export const PDFOutlineToggleButton = memo(() => {
  const { isLeftContentPanelTabOpen, showLeftContentPanel, closeLeftContentPanel } = useAssetModalLeftPanel();
  const isOutlineOpen = isLeftContentPanelTabOpen('pdfOutline');

  const handleToggleOutline = useCallback(() => {
    if (isOutlineOpen) {
      closeLeftContentPanel();
    } else {
      showLeftContentPanel('pdfOutline');
    }
  }, [closeLeftContentPanel, isOutlineOpen, showLeftContentPanel]);

  return (
    <IconButton
      adsIcon
      icon={isOutlineOpen ? PanelLeftCloseIcon : PanelLeftOpenIcon}
      label={isOutlineOpen ? 'Close PDF Outline' : 'Open PDF Outline'}
      appearance="ghost"
      color="gray"
      onClick={handleToggleOutline}
      data-testid="PDF_OUTLINE_TOGGLE_BUTTON"
    />
  );
});

PDFOutlineToggleButton.displayName = 'PDFOutlineToggleButton';
